module.exports = __webpack_public_path__ + "static/media/POS Application Certification Documents.0fcb5858.pdf";